var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03999 6.29036C4.29383 6.03652 4.70539 6.03652 4.95923 6.29036L7.99961 9.33074L11.04 6.29036C11.2938 6.03652 11.7054 6.03652 11.9592 6.29036C12.2131 6.5442 12.2131 6.95575 11.9592 7.20959L8.45923 10.7096C8.20539 10.9634 7.79383 10.9634 7.53999 10.7096L4.03999 7.20959C3.78615 6.95575 3.78615 6.5442 4.03999 6.29036Z",
    fill: "currentColor"
  })));
};
export default SvgChevronDown;